import { TextField } from '@mui/material'

function ClustersInput({ clusters, onChange }: { clusters: number; onChange: (event: number) => void }) {
  return (
    <TextField
      value={clusters}
      onChange={(event) => onChange(Number(event.target.value))}
      inputProps={{
        step: 1,
        role: 'input',
        min: 2,
        max: 16,
        type: 'number',
        'aria-label': 'Input number for slider'
      }}
    />
  )
}

export default ClustersInput
